/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SubmitterModel } from './SubmitterModel';
import {
    SubmitterModelFromJSON,
    SubmitterModelFromJSONTyped,
    SubmitterModelToJSON,
} from './SubmitterModel';

/**
 * 
 * @export
 * @interface PetCommentModel
 */
export interface PetCommentModel {
    /**
     * 
     * @type {number}
     * @memberof PetCommentModel
     */
    id?: number;
    /**
     * 
     * @type {SubmitterModel}
     * @memberof PetCommentModel
     */
    submitter?: SubmitterModel;
    /**
     * 
     * @type {string}
     * @memberof PetCommentModel
     */
    comment: string;
}

/**
 * Check if a given object implements the PetCommentModel interface.
 */
export function instanceOfPetCommentModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "comment" in value;

    return isInstance;
}

export function PetCommentModelFromJSON(json: any): PetCommentModel {
    return PetCommentModelFromJSONTyped(json, false);
}

export function PetCommentModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetCommentModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'submitter': !exists(json, 'submitter') ? undefined : SubmitterModelFromJSON(json['submitter']),
        'comment': json['comment'],
    };
}

export function PetCommentModelToJSON(value?: PetCommentModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'submitter': SubmitterModelToJSON(value.submitter),
        'comment': value.comment,
    };
}

